import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { useT } from '../i18n/LanguageContext';

/* ============================================================
   CheckoutResult — /checkout/sucesso, /checkout/erro, /checkout/cancelado
   ============================================================
   Páginas de regresso depois do pagamento por cartão no
   checkout alojado do ifthenpay (ver IfthenpayGateway no
   backend). Uma só página parametrizada por `variant`, ao
   estilo do padrão já usado em Territorio.js (mesmo componente,
   conteúdo diferente por rota).
   ============================================================ */

const VARIANTS = {
  sucesso: {
    titleKey: 'checkoutResult.success.title',
    leadKey: 'checkoutResult.success.lead',
  },
  erro: {
    titleKey: 'checkoutResult.error.title',
    leadKey: 'checkoutResult.error.lead',
  },
  cancelado: {
    titleKey: 'checkoutResult.cancelled.title',
    leadKey: 'checkoutResult.cancelled.lead',
  },
};

export default function CheckoutResult({ variant }) {
  const t = useT();
  const [searchParams] = useSearchParams();
  const orderId = searchParams.get('order');
  const { titleKey, leadKey } = VARIANTS[variant];

  return (
    <div className="page-top">
      <section className="section" style={{ paddingTop: 'calc(var(--nav-height) + var(--sp-16))' }}>
        <div className="container--narrow t-center">
          {orderId && (
            <p className="t-label" style={{ color: '#000000', marginBottom: 'var(--sp-3)' }}>
              {orderId}
            </p>
          )}
          <h1 className="t-h1">{t(titleKey)}</h1>
          <p className="t-body-lg t-light" style={{ marginTop: 'var(--sp-5)', marginBottom: 'var(--sp-10)' }}>
            {t(leadKey)}
          </p>
          <div className="flex gap-4 justify-center" style={{ flexWrap: 'wrap' }}>
            <Link to="/" className="btn btn-lg">{t('checkoutResult.cta1')}</Link>
            <Link to="/loja" className="btn btn-lg">{t('checkoutResult.cta2')}</Link>
          </div>
        </div>
      </section>
    </div>
  );
}
